<div class="weekly-schedule">
  <div class="d-flex justify-content-between align-items-start col-form-label pb-0 mb-1">
    @if (!callFlow().isAfterHoursCallFlow) {
      <div class="d-flex align-items-center gap-2">
        <div
          class="form-check form-switch switch-lg weekly-schedule__custom-toggle"
          data-automation="weekly-schedule-is-custom-switch"
        >
          <label class="form-check-label" for="weekly-schedule-custom-switch">
            {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.weekly_schedule.toggle' | translate }}
          </label>
          <input
            type="checkbox"
            class="form-check-input"
            id="weekly-schedule-custom-switch"
            role="switch"
            [ngModel]="isCustom()"
            (ngModelChange)="toggleCustom()"
            [attr.aria-checked]="isCustom()"
          />
        </div>
      </div>
    }
  </div>

  @if (callFlow().isAfterHoursCallFlow) {
    <div
      class="alert alert-info d-flex align-items-start gap-2 mt-3 mb-0"
      role="alert"
      data-automation="business-hours-managed-info"
    >
      <i class="fa fa-info-circle mt-1 flex-shrink-0"></i>
      <div>
        <strong
          [innerHTML]="
            'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.after_hours.weekly_schedule.helptext.title'
              | escapeHtml
          "
        ></strong>
        <br />
        <span
          [innerHTML]="
            'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.after_hours.weekly_schedule.helptext.one'
              | escapeHtml
          "
        ></span>
        <a
          href=""
          (click)="$event.preventDefault(); selectBusinessHoursFlow.emit()"
          data-automation="edit-business-hours-link"
        >
          {{
            'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.after_hours.weekly_schedule.helptext.two'
              | translate
          }}
        </a>
      </div>
    </div>
  }

  <!-- Quick set -->
  <div
    class="mb-1"
    [ngClass]="{ 'has-feedback has-error': isQuickRangeInvalid }"
    [hidden]="callFlow().isAfterHoursCallFlow || !isCustom()"
  >
    <label class="col-form-label col-12 pb-0 mb-1">
      {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.weekly_schedule.quick_set' | translate }}
    </label>
    <div class="d-flex gap-2 weekly-schedule__quick-actions">
      <ziro-button
        [icon]="ZiroIcons.CALENDAR_DAY_SMALL"
        [buttonSize]="ButtonSizes.MEDIUM"
        [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
        [isDisabled]="isQuickRangeInvalid"
        [dataAutomation]="'weekly-schedule-apply-weekdays-button'"
        [label]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.weekly_schedule.weekdays.label'"
        (clicked)="applyWeekdays()"
      ></ziro-button>
      <ziro-button
        [label]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.weekly_schedule.weekends.label'"
        [icon]="ZiroIcons.HOLIDAY_HOURS"
        [buttonSize]="ButtonSizes.MEDIUM"
        [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
        [dataAutomation]="'weekly-schedule-apply-weekend-days-button'"
        [isDisabled]="isQuickRangeInvalid"
        (clicked)="applyWeekendDays()"
      ></ziro-button>
    </div>
    <ziro-time-ranges
      [fieldId]="'slots'"
      [canAddRanges]="false"
      [dataAutomation]="'weekly-schedule-day-modal-time-ranges'"
      [hideDelete]="true"
      [inlineLabel]="false"
    ></ziro-time-ranges>
  </div>
  @if (isCustom() && !callFlow().isAfterHoursCallFlow) {
    <!-- Day cards -->
    <div class="weekly-schedule__grid" data-automation="weekly-schedule-day-grid">
      @for (day of days; track day.key) {
        <div
          class="weekly-schedule__day-card btn btn-border {{ ButtonStyles.OUTLINE_DEFAULT }} {{ ButtonSizes.MEDIUM }}"
          [ngClass]="{ 'weekly-schedule__day-card--open': isDayOpen(day.key) }"
          (click)="selectDay(day.key)"
          [attr.data-automation]="'weekly-schedule-day-card-' + day.key"
        >
          <div class="weekly-schedule__day-label" [attr.data-automation]="'weekly-schedule-day-label-' + day.key">
            {{ day.shortLabel }}
          </div>
          @if (isDayOpen(day.key)) {
            @let dayHours = getDayHours(day.key);
            @let remainingCount = getRemainingScheduleCount(dayHours);
            <div
              class="weekly-schedule__day-time"
              [ngbTooltip]="tooltipTpl"
              [tooltipContext]="{ spans: dayHours }"
              [disableTooltip]="remainingCount === 0"
              container="body"
              [attr.data-automation]="'weekly-schedule-day-time-' + day.key"
            >
              {{ getVisibleScheduleLabel(dayHours) }}
              @if (remainingCount > 0) {
                <span
                  class="weekly-schedule__day-more ms-1"
                  [attr.data-automation]="'weekly-schedule-day-more-' + day.key"
                >
                  +{{ remainingCount }}
                  {{
                    'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.weekly_schedule.more' | translate
                  }}
                </span>
              }
            </div>
            <ng-template #tooltipTpl let-spans="spans">
              <ul class="weekly-schedule__tooltip-list mb-0 ps-3">
                @for (span of spans; track $index) {
                  <li>{{ formatScheduleSpan(span.start, span.end) }}</li>
                }
              </ul>
            </ng-template>
          } @else {
            <div class="weekly-schedule__day-closed" [attr.data-automation]="'weekly-schedule-day-closed-' + day.key">
              {{
                'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.weekly_schedule.day_closed'
                  | translate
              }}
            </div>
          }
        </div>
      }
    </div>
  }
</div>
